/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadTargetHeader
 */
export interface UploadTargetHeader {
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    value: string;
}

/**
 * Check if a given object implements the UploadTargetHeader interface.
 */
export function instanceOfUploadTargetHeader(value: object): value is UploadTargetHeader {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function UploadTargetHeaderFromJSON(json: any): UploadTargetHeader {
    return UploadTargetHeaderFromJSONTyped(json, false);
}

export function UploadTargetHeaderFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadTargetHeader {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'value': json['value'],
    };
}

export function UploadTargetHeaderToJSON(json: any): UploadTargetHeader {
    return UploadTargetHeaderToJSONTyped(json, false);
}

export function UploadTargetHeaderToJSONTyped(value?: UploadTargetHeader | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'value': value['value'],
    };
}

